import '../styles/App.css';
import 'leaflet/dist/leaflet.css';


function App() {
  return (
    <div>
      <h1 className="p-10 text-5xl font-bold text-blue-600 text-center">Error 404</h1>
      <h1 className="text-1xl text-gray-200 text-center">
        Fish not found
      </h1>
    </div>
  );
}

export default App;
